// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__47jhf","left":"InfoRow_left__2Pbjl"};